module.exports = __webpack_public_path__ + "static/media/background-initial-mobile.e418a192.jpg";